import { defineStore } from 'pinia';
import { UserType } from '@/types';
import { ref } from 'vue';
import { UserApi } from '@/api';

export const useUserStore = defineStore('user', () => {
	const user = ref<UserType | null>(null);

	const getUserInfo = async () => {
		const res = await UserApi.getUserInfo();
		if(res){
			const { code, user: resUser, msg } = res;
			if(code !== 200) {
				console.error(msg);
			}
			user.value = resUser;
		}
		return res;
	};

	return { user, getUserInfo };
});
